import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import { storage } from "../firebase";
import moment from 'moment';
import { db, database, testimonialRef } from '../firebase'
import $ from 'jquery';
export default class NewTestimonials extends Component {
    constructor(props) {
        super(props)
        this.state = {
            testimonialImage: null,
            progress: 0,
            author: "",
            status: "",
            url: "",
            urlVideo:"",
            testimonialUrl: null,
            id: null,
            fileName:false,
            testimonialVideo: null,

        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.handleVideoChange = this.handleVideoChange.bind(this);
        this.validateSubmission = this.validateSubmission.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.updateValidateSubmission = this.updateValidateSubmission.bind(this)
    }
    updateValidateSubmission = () => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            author: this.state.author,
            imageUrl: this.state.url ? this.state.url : this.state.testimonialUrl  ,
            videoUrl: this.state.urlVideo ? this.state.urlVideo : this.state.testimonialVideo  ,
            status: this.state.status,
            createdAt: newDate
        }
        database.ref(`testimonials/${this.state.id}`).update(item).then(() => {
            alert("Updated Successfully")
            window.location.href = "/testimonials"
             this.renderList();
           
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    handleImageChange = e => {
        if (e.target.files[0]) {
            this.setState({
                testimonialImage: e.target.files[0],
                fileName:true
            })
        }
    };
    handleVideoChange = e => {
        if (e.target.files[0]) {
            this.setState({
                testimonialVideo: e.target.files[0],
                fileVideoName:true
            })
        }
    };
    handleStatusChange = (e) => {
        this.setState({
            status: e.target.value
        })
    }
    handleChange = (e) => {
        this.setState({
            author: e.target.value,
        });
    };
    validateSubmission = () => {
        console.log("testimonialVideo...",this.state.testimonialVideo)
        if (this.state.author === '') {
            alert('Enter Author')
        }
        else if (this.state.testimonialImage === '' || this.state.testimonialImage === null) {
            alert('Upload Image ')
        }
        else if (this.state.testimonialVideo === '' || this.state.testimonialVideo === null) {
            alert('Upload Video ')
        }
        else if (this.state.status === '') {
            alert('Select status')
        }
        else {
             if (this.state.fileName) {
                const uploadTask = storage.ref(`testimonials/${this.state.testimonialImage.name}`).put(this.state.testimonialImage);
                uploadTask.on(
                    "state_changed",
                    snapshot => {
                        const progress = Math.round(
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                        );
                        this.setState({
                            progress: progress
                        })
                    },
                    error => {
                        console.log(error);
                    },
                    () => {
                        storage
                            .ref("testimonials")
                            .child(this.state.testimonialImage.name)
                            .getDownloadURL()
                            .then(url => {
                                console.log("url...",url)
                                $("#imageUrl")
                                .attr('src', url);
                                this.setState({
                                    url: url
                                })
                               
                                // if (this.state.id == null) {
                                //     this.handleSubmit(url);
                                // }
                                // else {
                                //     this.updateValidateSubmission(url)
                                // }
                            });

                    }
                );
             }
            
              if (this.state.fileVideoName) {
                const uploadTask = storage.ref(`testimonials/${this.state.testimonialVideo.name}`).put(this.state.testimonialVideo);
                uploadTask.on(
                    "state_changed",
                    snapshot => {
                        const progress = Math.round(
                            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                        );
                        this.setState({
                            progress: progress
                        })
                    },
                    error => {
                        console.log(error);
                    },
                    () => {
                        storage
                            .ref("testimonials")
                            .child(this.state.testimonialVideo.name)
                            .getDownloadURL()
                            .then(url => {
                                console.log("url1111...",url)
                                $("#imageVideoUrl")
                                .attr('src', url);
                                this.setState({
                                    urlVideo: url
                                })
                                if (this.state.id == null ) {
                                    this.handleSubmit();
                                }
                                else {
                                    this.updateValidateSubmission()
                                }
                            });

                    }
                );
             }
            else {
                if (this.state.id == null) {
                    this.handleSubmit("");
                }
                else {
                    this.updateValidateSubmission("");
                }
            }
        }
    }
  
    handleSubmit = () => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            author: this.state.author,
            imageUrl: this.state.url ? this.state.url : this.state.testimonialUrl  ,
            videoUrl: this.state.urlVideo ? this.state.urlVideo : this.state.testimonialVideo  ,
            status: this.state.status,
            createdAt: newDate
        }
        testimonialRef.push(item).then(() => {
            alert("Saved Successfully")
            window.location.href = "/testimonials"
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    componentDidMount() {
        const url = new URL(window.location.href);
        let url_path = window.location.href.split("=");
        let keyId = (url_path[1]);
        this.renderList(keyId)
    }
    async renderList(keyId) {
        let dataList = []
        let id = keyId;
        const ref = id ? '/testimonials/' + id : 'testimonials'
        const userRef = database.ref(ref)
        const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
        const snapshot = await valueRef.once('value')
        const val = snapshot.val()
        if (val) {
            $("#testimonialAuthor").val(val.author)
            $("#testimonialImage").val(val.imageUrl)
            $("#testimonialVideo").val(val.videoUrl)
            $("#testimonialStatus").val(val.status)
            this.setState({
                testimonialUrl: val.imageUrl,
                id: id,
                author: val.author,
                status: val.status,
                testimonialImage: val.imageUrl,
                testimonialVideo: val.videoUrl
            })
        }
    }
    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <form className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li><a href="/testimonials">Testimonials</a></li>
                                    <li>New Testimonials</li>
                                </ul>
                                <div className='form-head'>Testimonials</div>
                                <div className="form-group">
                                    <label for="testimonialAuthor">Author</label>
                                    <input type="text" className="form-control" name="testimonialAuthor" onChange={this.handleChange}
                                        id="testimonialAuthor"
                                    />
                                </div>
                                <div className="form-group">
                                    <label for="imageUrl">Image</label>
                                    <input type="file" onChange={this.handleImageChange} id="imageUrl" name="imageUrl" className="form-group"></input>
                                     {this.state.fileName || this.state.testimonialUrl && <img src={this.state.testimonialUrl} id={"imageUrl"} style={{ width: "100px", height: "100px" }} />}
                                </div>
                                <div className="form-group">
                                    <label for="imageVideoUrl">Video</label>
                                    <input type="file" onChange={this.handleVideoChange} id="imageVideoUrl" name="imageVideoUrl" className="form-group"></input>
                                    {this.state.fileVideoName || this.state.testimonialVideo &&  <video src={this.state.testimonialVideo}  id="imageVideoUrl" style={{ width: "100px", height: "100px" }}  ></video>}
                                     {/* {this.state.fileVideoName || this.state.testimonialVideo && <img alt ="" src={this.state.testimonialVideo} id={"imageVideoUrl"} style={{ width: "100px", height: "100px" }} />} */}
                                </div>
                                <div className="form-group">
                                    <label for="testimonialStatus"> Status</label>
                                    <select className="form-control" onChange={this.handleStatusChange} id="testimonialStatus" name="testimonialStatus">
                                        <option value="">Select</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="form-group mt-4">
                                    <Link to="/testimonials">
                                        <button type="button" className="btn btn-primary" style={{ float:"right",marginLeft: "10px" }}>Cancel</button>
                                    </Link>
                                    {this.state.id == null ?
                                        <button type="button" className="btn btn-primary" onClick={this.validateSubmission} style={{ float:"right" }}>Submit</button>
                                        :
                                        <button type="button" className="btn btn-primary" onClick={this.validateSubmission} style={{ float:"right" }}>Update</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/admin/newTestimonials.jsx